import { apiGetFile, GetReportRequest } from 'api';

export const getLateResponsesReportCsv = (request: GetReportRequest): Promise<Blob> =>
  apiGetFile('reports/lateresponses/csv', request);
